import { BreadCrumb } from "primereact/breadcrumb";

import { Link, useLocation, useNavigate } from "react-router-dom";

import { Button } from "primereact/button";
import { SplitButton } from "primereact/splitbutton";
import { useParcelContext } from "./ParcelContext";

export const ParcelHeader = ({ sendPrintBillet }) => {
  const { state } = useLocation();
  const { idSale, toggleCheckboxes, isVisibleButtons, handleOptionSelect, permissions, typeSale } =
    useParcelContext();
  const navigate = useNavigate();
  const items = [
    {
      template: () => (
        <Link
          to={`/negotiations/${state.enterpriseId}`}
          state={{ name: state.enterpriseName }}
          className="p-breadcrumb-link"
        >
          Contratos
        </Link>
      ),
    },
    {
      template: () => (
        <Link
          to={"/enterprise/contracts/parcel"}
          state={state}
          className="p-breadcrumb-link"
        >
          Parcelas
        </Link>
      ),
    },
  ];
  const home = {
    template: () => (
      <Link to={"/dashboard"} className="p-breadcrumb-link">
        <i className="fa fa-home"></i>
      </Link>
    ),
  };
  const optionsParcel = [
    ...(permissions && permissions.includes("39") ? [ //Adicionar Parcela
      {
        label: "Adicionar Parcelas",
        icon: "fa fa-plus",
        command: () => handleOptionSelect("create_parcel"),
      },
    ] : []),
    ...(permissions && permissions.includes("40") ? [ //Atualizar Parcela
      {
        label: "Atualizar Parcelas",
        icon: "fa fa-pen-to-square",
        command: () => handleOptionSelect("update_installment"),
      },
    ] : [])
  ];

  const optionsAlter = [
    ...(permissions && permissions.includes("41") ? [ //Alterar Instrução da Parcela
      {
        label: "Alterar Instrução",
        icon: "fa fa-pen-to-square",
        command: () => handleOptionSelect("alter_desc"),
      },
    ] : []),
    ...(permissions && permissions.includes("42") ? [ //Alterar dia o Vencimento
      {
        label: "Alterar Dia Vencimento",
        icon: "fa fa-pen-to-square",
        command: () => handleOptionSelect("change_due_date"),
      },
    ] : []),
  ];
  const optionsActions = [
    ...(permissions && permissions.includes("43") && typeSale === "financing" ? [ //Antecipar Parcelas
      {
        label: "Antecipar Parcelas Regressivas",
        icon: "fa fa-clock-rotate-left",
        command: () => handleOptionSelect("anticipate_regressive"),
      },
      {
        label: "Antecipar Parcelas Selecionadas",
        icon: "fa fa-clock-rotate-left",
        command: () => handleOptionSelect("anticipate_selected"),
      },
    ] : []),
    ...(permissions && permissions.includes("44") && typeSale === "financing" ? [ //Desfazer Antecipação
      {
        label: "Desfazer Antecipação",
        icon: "fa fa-arrow-left",
        command: () => handleOptionSelect("remove_anticipate"),
      },
    ] : []),
    ...(permissions && permissions.includes("45") ? [ //Gerar Remessa
      {
        label: "Gerar Remessa",
        icon: "fa fa-file-arrow-up",
        command: () => handleOptionSelect("shipping"),
      },
    ] : []),

    ...(permissions && permissions.includes("46") ? [ //Reajustar Parcela 
      {
        label: "Reajuste",
        icon: "fa fa-comments-dollar",
        command: () => handleOptionSelect("readjust_installments"),
      },
    ] : []),
    ...(permissions && permissions.includes("47") ? [ //Solicitar Renegociação
      {
        label: "Renegociar",
        icon: "fa fa-arrows-rotate",
        command: () => handleOptionSelect("renegotiate"),
      },
    ] : []),

    ...(permissions && permissions.includes("48") ? [ //Vincular Parcelas 
      {
        label: "Vincular",
        icon: "fa fa-arrow-right",
        command: () => handleOptionSelect("link"),
      },
    ] : []),
    ...(permissions && permissions.includes("49") ? [ //Desvincular Parcelas 
      {
        label: "Desvincular",
        icon: "fa fa-arrow-left",
        command: () => handleOptionSelect("remove_link"),
      },
    ] : []),
    ...(permissions && permissions.includes("123") ? [ //Visualizar Parcelas Estornadas  
      {
        label: "Parcelas Estornadas",
        icon: "fa fa-clock-rotate-left",
        command: () => handleOptionSelect("reverse_installments"),
      },
    ] : []),
    ...(permissions && permissions.includes("45") ? [ //Gerar Remessa  
      {
        label: "Parcelas com Erro na Remessa",
        icon: "fa fa-clock-rotate-left",
        command: () => handleOptionSelect("reverse_shipping"),
      },
    ] : []),
  ];

  return (
    <>
      <div className="col-xl-4">
        <BreadCrumb model={items} home={home} className="breadCrumb" />
      </div>
      <div className="col-xl-8">
        <div className="row pb-3">
            {permissions && permissions.includes("38") && ( //Imprimir Boleto 
              <div className="p-2 col-xl-3 col-md-6">
                <Button
                  rounded
                  severity="info"
                  label={isVisibleButtons ? "Boleto" : "Voltar"}
                  icon="fa fa-money-check-dollar"
                  onClick={toggleCheckboxes}
                  className="p-inputtext-sm me-2 w-100 w-md-auto"
                />
              </div>
            )}
            {isVisibleButtons && (
              <>
                {permissions && (permissions.includes("39") || permissions.includes("40")) && ( // Adicionar Parcelas / Atualizar Parcela
                  <div className="p-2 col-xl-3 col-md-6">
                    <SplitButton
                      label="Parcelas"
                      icon="fa fa-dollar-sign"
                      model={optionsParcel}
                      rounded
                      className="pb-2 w-100 w-md-auto"
                    />
                  </div>
                )}
                {permissions && (permissions.includes("41") || permissions.includes("42")) && ( // Instrução da Parcelas / Alterar dia de Vencimento
                  <div className="p-2 col-xl-3 col-md-6">
                    <SplitButton
                      label="Alterar"
                      icon="fa fa-pen"
                      severity="warning"
                      model={optionsAlter}
                      rounded
                      className="pb-2 w-100 w-md-auto"
                    />
                  </div>
                )}

                {permissions &&
                  (permissions.includes("43") ||
                    permissions.includes("44") ||
                    permissions.includes("45") ||
                    permissions.includes("46") ||
                    permissions.includes("47") ||
                    permissions.includes("48") ||
                    permissions.includes("49") ||
                    permissions.includes("123") ||
                    permissions.includes("50")) && (
                    <div className="p-2 col-xl-3 col-md-6">
                      <SplitButton
                        label="Ações"
                        icon="fa fa-sliders"
                        severity="secondary"
                        model={optionsActions}
                        rounded
                        className="pb-2 w-100 w-md-auto"
                      />
                    </div>
                  )}
              </>
            )}
            {!isVisibleButtons && permissions && permissions.includes("38") && ( //Imprimir Boleto 
              <div className="p-2 col-xl-3 col-md-6">
                <Button
                  rounded
                  severity="warning"
                  label="Imprimir Boletos"
                  icon="fa fa-money-check-dollar"
                  onClick={sendPrintBillet}
                  className="p-inputtext-sm me-2 w-100 w-md-auto"
                />
              </div>
            )}
        </div>
      </div>
    </>

  );
};
